import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { 
  delay, find, concat, reject as lodashReject,
  map, reduce, indexOf, groupBy,
} from 'lodash';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { 
  Modal, Button, Tooltip, OverlayTrigger,
  ControlLabel, FormGroup, FormControl,
} from 'react-bootstrap';
import NumberDisplay from '../number-display';
import Avatar from '../avatar';

import AlertIcon from '../alert-icon';
import styles from './styles.css';
import { getUsers, shareSearch } from './search-form-actions';
import { getUser } from '../../modules/Auth/AuthReducer';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function blurAll(parent = document.body) {
  const tmp = document.createElement('input');
  tmp.className = styles.hiddenInput;
  parent.appendChild(tmp);
  delay(() => {
    tmp.focus();
    parent.removeChild(tmp);
  }, 1);
}
const FadeAnimation = ({ children, ...props }) => (
  <CSSTransition
    {...props}
  >
    {children}
  </CSSTransition>
);
FadeAnimation.propTypes = {
  children: PropTypes.element,
};
FadeAnimation.defaultProps = {
  children: null,
};

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      submitting: false,
      success: false,
      value: '',
      values: [],
      loading: false,
      focus: false,
      suggestions: [],
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.share = this.share.bind(this);
  }

  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onFocus() {
    this.setState({ focus: true });
  }

  onBlur() {
    this.setState({ focus: false });
  }

  // Autosuggest will call this function every time
  // you need to update suggestions.
  onSuggestionsFetchRequested({ value }) {
    if (value && value.length > 0) {
      const escapedValue = escapeRegexCharacters(value.trim());
      // const regex = new RegExp(`${escapedValue}`, 'i');
      this.setState({ loading: true, suggestions: [] });
      const { values } = this.state;
      const { auth } = this.props;
      const existentIds = map(values, '_id');
      existentIds.push(auth._id);

      const p = new Promise((resolve, reject) => {
        this.props.dispatch(getUsers(escapedValue))
          .then(
            (users) => {
              const validUsers = reduce(users, (items, user) => {
                if (indexOf(existentIds, user._id) < 0) {
                  items.push(user);
                }
                return items;
              }, []);
              const results = reduce(groupBy(validUsers, 'organization_name'), (items, suggestions, title) => {
                items.push({ title, suggestions });
                return items;
              }, []);
              resolve(results);
            },
            (errors) => {
              console.log('errors', errors);
              reject(errors);
            },
          );
      });
      p.then(
        (suggestions) => {
          this.setState({ suggestions, loading: false });
        },
        () => {
          this.setState({ suggestions: [], loading: false });
        },
      );
      return p;
    }

    return Promise.resolve([]);
  }
  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected(event, { suggestion }) {
    if (!suggestion.isEmpty && !suggestion.isHeader) {
      const { values } = this.state;
      const exist = find(values, { _id: suggestion._id });
      if (!exist) {
        const newValues = concat(values, suggestion);
        this.setState({ values: newValues });
      }
    }
    this.setState({ value: '' });
    blurAll(this.element);
  }
  getSuggestionValue(suggestion) {
    if (suggestion.isHeader || suggestion.isEmpty) {
      return '';
    }
    return suggestion.label;
  }

  getSectionSuggestions(section) {
    return section.suggestions;
  }

  removeTag(suggestion) {
    const { values } = this.state;
    const newValues = lodashReject(values, val => val._id === suggestion._id);
    this.setState({ values: newValues });
  }

  open() {
    this.setState({ open: true, success: false, submitting: false, values: [] });
    this.props.onModalShow();
  }

  close() {
    const { success } = this.state;
    this.setState({ open: false });
    delay(() => {
      this.setState({ success: false });
    }, 500);
    if (success) {
      this.props.onSuccess();
    }
    this.props.onModalHide();
  }

  share() {
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });
    const { savedSearch } = this.props;
    const { values } = this.state;
    const ids = map(values, '_id');
    return this.props.dispatch(shareSearch(savedSearch._id, ids))
      .then(
        () => {
          this.setState({ submitting: false, success: true });
        },
        () => {
          this.setState({ submitting: false, success: false });
        },
      );
  }

  renderSuggestion(suggestion, { query }) {
    const label = suggestion.display_name || suggestion.nick_name || suggestion.username;
    const matches = match(label, query);
    const parts = parse(label, matches).map((part, id) => ({ ...part, id }));
    return (
      <a href="" onClick={(e) => { e.preventDefault(); }}>
        <Avatar size={22} className={styles.suggestionAvatar} user={suggestion} />
        <span>
          {parts.map((part) => {
            const className = part.highlight ? styles.tagHighlight : null;
            return (
              <span className={className} key={part.id}>
                {part.text}
              </span>
            );
          })}
        </span>
      </a>
    );
  }

  renderSectionTitle(section) {
    return section.title;
  }


  renderForm() {
    const {
      value, suggestions, focus,
      loading, submitting, values,
    } = this.state;
    const { savedSearch } = this.props;


    const inputProps = {
      placeholder: 'type a user name...',
      value,
      className: styles.tagInput,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      disabled: submitting,
    };
    const theme = {
      container: styles.autocomplete,
      suggestionsContainer: `dropdown open ${styles.suggestionsContainer}`,
      sectionContainer: `dropdown-menu ${styles.sectionContainer}`,
      suggestionsList: `dropdown-menu ${styles.suggestionsList}`,
      sectionTitle: 'dropdown-header',
      suggestion: '',
      suggestionFocused: 'active',
    };


    const cls = [styles.tagInputField];
    if (focus) {
      cls.push(styles.tagInputFieldFocus);
    }
    if (loading) {
      cls.push(styles.tagInputFieldLoading);
    }
    const total = values.length;
    const valid = total > 0;
    const displayTitle = false;
    return (
      <div>
        <Modal.Body>
          {displayTitle &&
            <FormGroup>
              <ControlLabel>Filter set:</ControlLabel>
              <FormControl disabled readOnly value={savedSearch.name} />
            </FormGroup>
          }
          <FormGroup>
            <ControlLabel>Select users to share</ControlLabel>
            <div
              ref={(el) => { this.element = el; }}
              className={`${cls.join(' ')}`}
            >
              <TransitionGroup className={styles.tagList}>
                {values.map((tag) => {
                  const tCls = [styles.tag];
                  tCls.push(styles.valueTag);
                  tCls.push(styles.userTag);
                  if (submitting) {
                    tCls.push(styles.disabledTag);
                  }
                  const label = tag.display_name || tag.nick_name || tag.username;
                  return (
                    <FadeAnimation
                      classNames="tag"
                      timeout={500}
                      key={tag._id}
                    >
                      <span className={`${tCls.join(' ')}`}>
                        <Avatar className={styles.tagAvatar} size={22} user={tag} />
                        <span className={styles.tagLabel}>{label}</span>
                        <a
                          href
                          className={styles.tagTrash}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!submitting) {
                              this.removeTag(tag);
                            }
                          }}
                        >
                          <Fa name="times" />
                        </a>
                      </span>
                    </FadeAnimation>
                  );
                })}
                <FadeAnimation
                  classNames="tag"
                  timeout={500}
                >
                  <div className={styles.autocompleteWrapper}>
                    <Autosuggest
                      theme={theme}
                      suggestions={suggestions}
                      multiSection
                      renderSectionTitle={this.renderSectionTitle}
                      getSectionSuggestions={this.getSectionSuggestions}
                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                      shouldRenderSuggestions={() => true}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      onSuggestionSelected={this.onSuggestionSelected}
                      getSuggestionValue={this.getSuggestionValue}
                      renderSuggestion={this.renderSuggestion}
                      inputProps={inputProps}
                    />
                    <Fa name="spinner" spin className={styles.spinner} />
                  </div>
                </FadeAnimation>
              </TransitionGroup>
            </div>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button bsStyle="link" className="pull-left" disabled={submitting} onClick={this.close}>
              Cancel
            </Button>
            <Button bsStyle="primary" onClick={this.share} disabled={submitting || !valid} type="submit">
              {!submitting &&
                <span>
                  {total === 0 && <span>Share</span>}
                  {total > 0 && <span>Share to <NumberDisplay value={total} suffix="user" precision={0} suffixIsUnit /></span>}
                </span>
              }
              {submitting && <span><Fa name="spinner" spin /> Sharing</span>}
            </Button>
          </div>
        </Modal.Footer>
      </div>
    );
  }
  renderModal() {
    const { open, success } = this.state;
    return (
      <Modal show={open} bsSize={success ? 'sm' : null} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Share Filter Set</Modal.Title>
        </Modal.Header>
        {!success && this.renderForm()}
        {success &&
          <div>
            <Modal.Body>
              <div className="text-center">
                <AlertIcon />
                <p>Filter set has been shared!</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="primary"
                bsSize="lg"
                block
                onClick={this.close}
              >
                Done
              </Button>
            </Modal.Footer>
          </div>
        }
      </Modal>
    );
  }

  render() {
    const {
      disabled, children, bsStyle, bsSize,
      tooltip,
    } = this.props;
    let comp = (
      <Button
        disabled={disabled}
        bsStyle={bsStyle}
        bsSize={bsSize}
        onClick={this.open}
      >
        {children}
      </Button>
    );
    if (tooltip) {
      const tip = (
        <Tooltip id="saved-search-edit-tip">
          <div>{tooltip}</div>
        </Tooltip>
      );
      comp = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {comp}
        </OverlayTrigger>
      );
    }
    return (
      <span>
        {this.renderModal()}
        {comp}
      </span>
    );
  }
}

ShareButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  onModalShow: PropTypes.func,
  onModalHide: PropTypes.func,
  savedSearch: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  tooltip: PropTypes.string,
  auth: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
ShareButton.defaultProps = {
  onModalShow: () => {},
  onModalHide: () => {},
  onSuccess: () => {},
  disabled: false,
  children: (<span>Share Filter Set</span>),
  bsStyle: 'link',
  bsSize: null,
  tooltip: null,
};

ShareButton.contextTypes = {
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    auth: getUser(state),
  };
}


export default connect(mapStateToProps)(ShareButton);
